import { getProducts } from "../../services/productService";
import { AppDispatch, RootState } from "../../store/store";
import "./Home.scss";
import BannerInfo from "./components/BannerInfo/BannerInfo";
import Confiance from "./components/Confiance/Confiance";
import Engagement from "./components/Engagement/Engagement";
import Experience from "./components/Experience/Experience";
import NeedHelp from "./components/NeedHelp/NeedHelp";
import Nitido from "./components/Nitido/Nitido";
// import ProductCarousel from "./components/ProductCarousel/ProductCarousel";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const Home = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { products } = useSelector((state: RootState) => state.products);

  useEffect(() => {
    products.items.length === 0 && dispatch(getProducts({}));
  }, [dispatch, products.items]);

  // const getRandomNumbers = useMemo(() => {
  //   const numbers = Array.from(
  //     { length: products.items.length },
  //     (_, i) => i + 1
  //   );
  //   const shuffled = numbers.sort(() => Math.random() - 0.5);
  //   return shuffled.slice(0, Math.min(9, products.items.length));
  // }, [products.items.length]);

  return (
    <div id="home">
      <Experience />
      {/* <div id="carousel-list">
        <p>Les produits préférés de nos clients</p>
        <ProductCarousel
          products={products.items.filter((_, idx) =>
            getRandomNumbers.includes(idx)
          )}
        />
      </div> */}
      <BannerInfo />
      <Engagement />
      <Nitido />
      <Confiance />
      <NeedHelp />
    </div>
  );
};

export default Home;
